import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class LabelsColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.Labels
  declare readonly dataType: typeof MemexColumnDataType.Labels
  declare readonly userDefined: false
}
